import React, { FC, useEffect, useRef, useState } from "react";
import { Button, Table, Input, message, Upload, Checkbox, Tooltip, Image } from "antd";
import { YhBox } from "@/components/YhBox";
import { ColumnsType } from "antd/es/table";
import { RouterParamType } from "@/model/navModel";
import { EditableRow, EditableCell } from "@/components/YHEditTable/editTable";
import useGlobalModel from "@/model/globalModel";
import { useDictModel } from "@/views/base/dict/dictModel";
import { formatInt, formatNum, formatDiscount } from "@/utils/utils";
import { YhAuth } from "@/components/auth/YhAuth";
import { ISCMSDcGoodsDetail } from "../../assetsMoveTypes";
import { useAssetsMoveDetailsModel } from "./assetsMoveDetailsModel";
import { DictCodeEnmu } from "@/types/AppDictEnums";
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { warehouseService } from "@/views/base/warehouseManage/warehouseService";
import { globalPrompt } from "@/components/message";
import { debounce } from "lodash";
import { assetsMoveService } from "../../assetsMoveService";
import { getBaseImgLookUrl } from "@/utils/constants";
import { ResourceAuthEnum } from '@/types/AppResourceAuthEnum'
import YhTootip from "@/components/YhTootip";

type ISCMSDcGoodsSearch = {
    data: ISCMSDcGoodsDetail[],
    isSearch: boolean
}

export const TableBox: FC<RouterParamType> = ({ id, mode }) => {
    const { warehouseList, setLoadingInfo, shopAndOrg, userList, userOrgList, fetchUserList } = useGlobalModel();
    const { getSelectedDictValueOne, getSelectedDictOne, getTreeNodeName } = useDictModel(() => []);
    const { addGoodsList, addFormVal, editFormVal, editFormVal: { status }, setHistoryVisible, historyRow, historyVisible, setButtonControl,
        setHistoryRow, setAddGoodsList, editGoodsList, setEditGoodsList, setSaveBtn, setAddGoodsModal } = useAssetsMoveDetailsModel();
    const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);
    const [searchParms, setSearchParms] = useState<string>("");
    const [searchVal, setSearchVal] = useState<ISCMSDcGoodsSearch>({ data: [], isSearch: false });   //用于搜索展示的数据
    const [selectedRowRows, setSelectedRowRows] = useState<any>([]);
    const formRef = useRef<any>()


    //删除商品
    const onRemove = () => {
        if (!selectedRowKeys.length) {
            message.warning("请选择你要删除的商品");
            return;
        }
        mode === "edit" ?
            setEditGoodsList(origin => origin.filter(item => selectedRowKeys.indexOf(item.temporaryId) < 0)) :
            setAddGoodsList(origin => origin.filter(item => selectedRowKeys.indexOf(item.temporaryId) < 0));

        let newSearchData = searchVal.data.filter(item => selectedRowKeys.indexOf(item.temporaryId) < 0)
        setSearchVal({ data: newSearchData, isSearch: searchVal.isSearch });
        mode === "add" ? setButtonControl(false) : setButtonControl(true)
        setSelectedRowKeys([]);
        message.success("删除成功");
    }
    //实时详情列表货位数据
    const [shelfAllList, setShelfAllList] = useState<any>([]);
    const changeshelfCode = async (value, options) => {
        let newRecords: any = []
        let params = {
            pageSize: 99999,
            pageNum: 1,
            ...shopAndOrg,
            warehouseId: warehouseList.find((item) => item.value === value.warehouseCode)?.id,
            warehouseCode: value.warehouseCode,
            enable: "1"
        }
        const { retData: shelfAll } = await warehouseService.shelfAllPage(params)
        newRecords = shelfAll.map((item) => { return { ...item, label: (item.code as string), value: item.code, } })
        setShelfAllList(newRecords);
    }
    // 打印标签
    const printGoodTip = async () => {

        if (!selectedRowRows.length) {
            message.warning("请选择你要打印的商品");
            return;
        }
        let materialNamelist: string[] = []
        let details: any = []
        selectedRowRows.map((item) => {
            materialNamelist.push(item.materialName)
            details.push({
                barCode: item.barCode,
                user: item.user,
                departmentName: item.departmentName,
                materialName: item.materialName,
                shelfCode: item.deposit ?? ""
            })
        })
        // 弹框
        globalPrompt('modal', {
            title: '打印标签',
            type: 'warning',
            text: `您是否打印${materialNamelist.toString()}标签？`,
            okText: '确认',

            onOk: debounce(async () => {
                try {
                    let result = await assetsMoveService.printGoodTip({
                        details,
                        type: "assets.transfer"
                    });
                    result && message.success('标签打印成功！')
                } catch (error) {
                    message.error('标签打印失败！')
                }
            }, 500),
            cancelText: '取消',
            onCancel: () => { },
        })


    }

    //搜索  前端自己保存搜索的值， 搜索值为空还是用缓存
    const goodsFilter = (dataSource: ISCMSDcGoodsDetail[] | null = null) => {
        const isEtit = mode !== "add";
        let goodsList = dataSource ? dataSource : [...(isEtit ? editGoodsList : addGoodsList)];
        if (searchParms) {
            let reg = new RegExp(searchParms);
            let arr: ISCMSDcGoodsDetail[] = [];
            goodsList.forEach(item => {
                if (item.materialCode?.match(reg) || item.materialName?.match(reg)) {
                    arr.push(item);
                }
            })

            setSearchVal({ data: arr, isSearch: true });

            if (!arr.length) {
                message.warning("列表没有该商品！！")
                setSearchVal({ data: [], isSearch: false });

            }
        } else {
            setSearchVal({ data: [], isSearch: false });
        }
    }
    const onfocusUserCode = () => {
        fetchUserList(mode == 'add' ? addFormVal.department : editFormVal.department)
    }

    // 新增
    const onAdd = () => {
        if (!(mode == 'add' ? addFormVal.department : editFormVal.department)) {
            return message.warning('请先选择，转入部门')
        }
        if (!(mode == 'add' ? addFormVal.departmentOut : editFormVal.departmentOut)) {
            return message.warning('请先选择，转出部门')
        }
        setAddGoodsModal(true)
    }

    const action = <div className="flex justify-between white-space">
        <div>
            <YhAuth resCode={ResourceAuthEnum.ASSETS_S_M_ED_AD}>
                <Button
                    className="mr-5"
                    type="link"
                    shape="round"
                    onClick={onAdd}
                    disabled={mode == 'look'}
                >新增物品</Button>
            </YhAuth>
            <YhAuth resCode={ResourceAuthEnum.ASSETS_S_M_ED_DEL}>
                <Button
                    className="mr-5"
                    type="link"
                    shape="round"
                    onClick={() => onRemove()}
                    disabled={mode == 'look'}
                >删除物品</Button>
            </YhAuth>
            {/* <Button
                    className="mr-5"
                    type="link"
                    shape="round"
                    disabled={mode=='look'}
                >导入</Button> */}
            <YhAuth resCode={ResourceAuthEnum.ASSETS_S_M_ED_PRINT_LABEL}>
                <Button
                    className="mr-5"
                    type="link"
                    shape="round"
                    onClick={() => printGoodTip()}
                >打印标签</Button>
            </YhAuth>
        </div>
        <div className="flex">
            <Input
                size="small"
                allowClear
                datatype="round"
                className="border-r-8 ml-10"
                placeholder="物资编号/物资名称"
                onChange={(e) => { setSearchParms(e.target.value) }}
                onBlur={(e) => setSearchParms(e.target.value?.trim())}
            // onPressEnter={() => goodsFilter()}
            />
            <Button type="primary" style={{ margin: "0px 12px 0px 15px" }} shape="round" onClick={() => goodsFilter()}> 查询</Button>
        </div>
    </div>;


    const columns = [
        {
            title: '序号',
            width: 40,
            fixed: "left",
            align: "center",
            render: (t: any, r: any, i: number) => i + 1
        }, {
            title: '物资图片',
            width: 140,
            align: "center",
            fixed: "left",
            render: (text, records) => (records.md5 ? <Image src={getBaseImgLookUrl(records.md5)} style={{ maxWidth: '50px', maxHeight: '70px' }} /> : null)
        }, {
            title: '物资编码',
            width: 140,
            dataIndex: 'materialCode',
            fixed: "left",
        }, {
            title: '物资名称',
            width: 160,
            dataIndex: 'materialName',
            fixed: "left",
        }, {
            title: '物资类型',
            width: 100,
            dataIndex: 'typeCode',
            render: (text: string) => getTreeNodeName(text) ?? ''
        }, {
            title: '规格型号',
            width: 130,
            dataIndex: 'model',
            render: (text: string) => <YhTootip text={text} />,
        }, {
            title: '单位',
            width: 80,
            dataIndex: 'unitCode',
            render: (text: string) => getSelectedDictOne(DictCodeEnmu.ASSETS_UNIT).find((item) => item.value === text)?.label ?? '',
        }, {
            title: '单价',
            width: 90,
            dataIndex: 'price',
            render: (text: any) => `￥${formatNum(text)}`
        }, {
            title: '转移数量',
            width: 100,
            dataIndex: 'num',
        }, {
            title: '合计',
            width: 100,
            dataIndex: 'amount',
            render: (text: any) => `￥${formatNum(text ?? 0)}`
        },
        {
            title: '原存放地点',
            width: 130,
            dataIndex: 'beforeDeposit',
        },
        {
            title: '原使用人',
            width: 120,
            dataIndex: 'beforeUser',
        },
        {
            title: '转入地点',
            width: 130,
            dataIndex: 'deposit',
            editable: mode == 'add' ? true : false
        },
        {
            title: '备注',
            width: 140,
            dataIndex: 'note',
            editable: mode == 'add' ? true : false
        },
        {
            title: '仓库',
            width: 130,
            dataIndex: 'warehouseCode',
            editable: mode == 'add' ? true : false,
            editType: 'select',
            options: warehouseList,
            // onSelectChange:changeWarehouseCode,
            render: (text: string) => warehouseList.find((item) => item.value === text)?.label ?? '请选择仓库',
            fixed: "right",
        },
        {
            title: '货位',
            width: 170,
            dataIndex: 'shelfCode',
            editType: 'select',
            options: shelfAllList,
            onSelectFocus: changeshelfCode,
            fixed: "right",
            editable: mode == 'look' ? false : true
        },
        {
            title: '现使用人',
            width: 120,
            dataIndex: 'userCode',
            editable: true,
            editType: 'select',
            options: userOrgList,
            // onSelectFocus:onfocusUserCode,
            render: (text: string, r) => userOrgList.find((item) => item.value === text)?.name ?? r.user,
            fixed: "right",
        },

    ];

    const newSelectColumns = columns.map((col: any, index) => {
        return {
            ...col,
            onCell: (record: any, rowIndex: number) => ({
                colIndex: index + 1,
                rowIndex,
                record,
                rules: col?.rules,
                options: col?.options,
                editType: col?.editType,
                editable: mode == 'look' ? false : col?.editable,
                onSelectChange: col?.onSelectChange,
                onSelectFocus: col?.onSelectFocus,
                dataIndex: col.dataIndex,
                title: col.title,
                handleSave: handleSave,
                onClear: col?.onClear,
            }),
        }
    })

    //内联编辑   (计算价格)
    const handleSave = (row: ISCMSDcGoodsDetail) => {

        let dataSource = mode === "edit" ? editGoodsList : addGoodsList
        const index = dataSource.findIndex((item) => row.temporaryId ? row.temporaryId === item.temporaryId : row.detailsId === item.detailsId);
        const item = dataSource[index];
        if (row.changeFields == "warehouseCode") {
            row.warehouseName = warehouseList.find((item) => item.value === row.warehouseCode)?.label
            row.shelfCode = ""
        }
        if (row.changeFields == "userCode") {
            row.userCode = row.userCode ?? ''
            row.user = userOrgList.find((item) => item.value === row.userCode)?.name ?? ""
        }
        dataSource.splice(index, 1, { ...item, ...row });
        mode === "edit" ? setEditGoodsList([...dataSource]) : setAddGoodsList([...dataSource]);
        //判断展示的是搜索后的数据，然后搜索的也改变
        if (searchVal.isSearch) {
            goodsFilter(dataSource)
        }
        setButtonControl(true)
        setSaveBtn(true)
    }

    return (
        <YhBox title="" action={action} style={{ marginBottom: "75px" }}>
            <Table
                rowKey={record => record.temporaryId}
                rowClassName={(record) => {
                    if (!record?.isHave || record.error) return "editable-row yh-edit-table-tr background-FFB4B4";
                    return "editable-row yh-edit-table-tr"
                }}
                rowSelection={{
                    selectedRowKeys: selectedRowKeys, //记录选中
                    onChange: (selectedRowKeys: React.Key[], selectedRows: ISCMSDcGoodsDetail[]) => {
                        setSelectedRowKeys(selectedRowKeys as string[]);
                        setSelectedRowRows(selectedRows)
                    }
                }}
                bordered
                components={{
                    body: {
                        row: EditableRow,
                        cell: EditableCell,
                    },
                }}
                columns={newSelectColumns as ColumnsType<ISCMSDcGoodsDetail>}
                dataSource={searchVal.isSearch ? searchVal.data : mode === "add" ? addGoodsList : editGoodsList}
                pagination={false}
                scroll={{ x: 'max-content' }}
            />
        </YhBox>
    )
}